
import {FiveCardRisk} from "five_card_risk";
import sea_background from 'sea_background';

export default class desertgoldFiveCardRisk extends FiveCardRisk {

    constructor(config) {

        super(config);

        this.animateBack = new sea_background();
        this.background.addChild(this.animateBack);

        const playingField = new PIXI.Sprite(PIXI.utils.TextureCache["double_playing_field.png"]);
        playingField.position.set(0, 144);
        this.background.addChild(playingField);

        const gambleAmountMark = new PIXI.Sprite(PIXI.utils.TextureCache["double_gamble_amount.png"]);
        gambleAmountMark.position.set(52, 17);
        this.background.addChild(gambleAmountMark);

        const gambleToWinMark = new PIXI.Sprite(PIXI.utils.TextureCache["double_gamble_to_win.png"]);
        gambleToWinMark.position.set(551, 17);
        this.background.addChild(gambleToWinMark);

        const dealerMark = new PIXI.Sprite(PIXI.utils.TextureCache["double_dealer.png"]);
        dealerMark.position.set(170, 520);
        dealerMark.anchor.x = 0.5;
        this.addChild(dealerMark);

        const bannerCoords = {x: 512, y: 86};

        this.playerWinBanner = new PIXI.Sprite(PIXI.utils.TextureCache["double_win.png"]);
        this.playerWinBanner.anchor.x = 0.5;
        this.playerWinBanner.position.set(bannerCoords.x, bannerCoords.y);
        this.playerWinBanner.visible = false;
        this.addChild(this.playerWinBanner);

        this.playerLoseBanner = new PIXI.Sprite(PIXI.utils.TextureCache["double_lose.png"]);
        this.playerLoseBanner.anchor.x = 0.5;
        this.playerLoseBanner.position.set(bannerCoords.x, bannerCoords.y);
        this.playerLoseBanner.visible = false;
        this.addChild(this.playerLoseBanner);

        this.forwardBanner = new PIXI.Sprite(PIXI.utils.TextureCache["double_forward.png"]);
        this.forwardBanner.anchor.x = 0.5;
        this.forwardBanner.position.set(bannerCoords.x, bannerCoords.y - 21);
        this.forwardBanner.visible = false;
        this.addChild(this.forwardBanner);

        this.currentRiskStepLabel = new PIXI.extras.BitmapText("", {font: "gamble_iterator_font", align: "center"});
        this.addChild(this.currentRiskStepLabel);
        this.currentRiskStepLabel.position.set(600, 162);
        this.currentRiskStepLabel.anchor.set(0.5, 0);
        this.currentRiskStepLabel.text = "0";

        const gambleAmountLabel = new PIXI.Sprite(PIXI.utils.TextureCache["gamble amount.png"]);
        gambleAmountLabel.anchor.x = 0.5;
        gambleAmountLabel.position.set(350, 430+107);
        this.addChild(gambleAmountLabel);

        const gambleToWinLabel = new PIXI.Sprite(PIXI.utils.TextureCache["gamble to win.png"]);
        gambleToWinLabel.anchor.x = 0.5;
        gambleToWinLabel.position.set(700, 430+107);
        this.addChild(gambleToWinLabel);

        this.sndLose = sounds.get("res/sounds/doublegame/risk_lose");

        this.sndWin = sounds.get("res/sounds/doublegame/risk_win");

        this.sndRotate = sounds.get("res/sounds/doublegame/rotate");

        this.sndBackground = sounds.get("res/sounds/doublegame/risk_background");
        this.sndBackground.loop(true);

        this.roundCards = null;
        this.cardChoice = -1;

    };
    
    terminate() {

        this.sndLose.stop();
        this.sndWin.stop();
        this.sndRotate.stop();
        this.sndBackground.stop();

        this.animateBack.terminate();

        super.terminate();

        this.currentRiskStepLabel = null;
        this.playerWinBanner = null;
        this.playerLoseBanner = null;
        this.forwardBanner = null;
        this.sndLose = null;
        this.sndWin = null;
        this.sndRotate = null;
        this.sndBackground = null;
        this.roundCards = null;
        this.cardChoice = null;

        this.animateBack = null;
    };
    
    
    /**
     * Makes scene paused
     * @memberOf DoubleGameScene
     * @override
     * */
    pause() {

        this.sndBackground.stop();
        this.roundCards = null;
        this.cardChoice = -1;

        this.animateBack.stopAnimate();
    };

    startRound( data, $startComplete ) {

        if (this.sndBackground.playing() === false) {
            this.sndBackground.play();
        }

        super.startRound(data, $startComplete);

        this.playerWinBanner.visible = false;
        this.playerLoseBanner.visible = false;
        this.forwardBanner.visible = false;
    };

    showRiskResult(data, done) {

        this.roundCards = data.processed.cards;
        this.cardChoice = data.processed.choice;

        super.showRiskResult(data, done);
    };

    onPlayerWin(currentWin, futureWin) {

        this.sndWin.play();
        this.playerWinBanner.visible = true;

        super.onPlayerWin(currentWin, futureWin);
    };

    onPlayerLose() {

        this.sndLose.play();
        this.playerLoseBanner.visible = true;

        super.onPlayerLose();
    };

    onForwardEvent() {

        this.forwardBanner.visible = true;

        super.onForwardEvent();
    };

    gotoNextRiskStep() {

        this.playerWinBanner.visible = false;
        this.playerLoseBanner.visible = false;
        this.forwardBanner.visible = false;
    };

    setRiskStep(step) {
        super.setRiskStep(step);
        this.currentRiskStepLabel.text = step;
    };


    /**
     * Open the card
     * @param {Number} id index of flipping card
     * @param {Number} cardId index in card deck of flipping card
     *
     * * */
    openCard(id, cardId, done) {

        this.sndRotate.play();

        super.openCard(id, cardId, done);
    };

    createCard(suite, nominal) {

        let suiteName = null;
        switch (suite) {
            case 0:
                suiteName = "hearts";
                break;
            case 1:
                suiteName = "diamonds";
                break;
            case 2:
                suiteName = "spades";
                break;
            case 3:
                suiteName = "clubs";
                break;
        }

        const card = new PIXI.Sprite(PIXI.utils.TextureCache[suiteName+"_"+nominal+".png"]);
        card.anchor.set(0.5, 0);

        return card;
    };


}



// WEBPACK FOOTER //
// ./src/doublegamescene.es6